//
import PaymentConditionModel from '@/models/Purchase/PchPaymentCondition'
import ProductModel from '@/models/Warehouse/WhProductToSearch'
import ProductServiceModel from '@/models/Warehouse/WhProductService'
import ProviderModel from '@/models/Purchase/PchProvider'
import PurchaseOrderDetailModel from '@/models/Purchase/PchDetailPurchaseOrder'
import WarehouseModel from '@/models/Warehouse/WhWarehouse'
import UserModel from '@/models/General/GUser'

//
import DetailPurchaseOrderHeaders from '@/views/Purchase/PchPurchaseOrder/PchDetailPurchaseOrderHeaders'
import ProductFilters from '@/views/Warehouse/WhProduct/list/filters'
import ProductHeaders from '@/views/Warehouse/WhProduct/WhProductHeaders'
import ProductServiceFilters from '@/views/Warehouse/WhProductService/WhProductServiceFilters'
import ProductServiceHeaders from '@/views/Warehouse/WhProductService/WhProductServiceHeaders'

//
import { required } from '@/services/validations'
import {
    PurchaseOrderDetailHeaders,
    PurchaseOrderOrdererHeaders,
} from './headers'

//
import { RequiredRule } from '@/mixins/reusable_mixins/rules'

/**
 * @description
 * Parser of selected collection 'pch_selected_purchase_orders'
 *
 * @param      {object}  props   properties
 * @return     {DetailPurchaseOrder}  detail purchase order class
 */
const selected_parser = props => row => row.toDetailPurchaseOrder({ 
    g_branch_office_id: props.g_branch_office_id 
})

//
export default props => [
    {
        name: 'g_originator_user_id',
        type: 'autocomplete-model',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            itemText: 'full_name',
            itemValue: 'id',
            label: 'Responsable',
            model: UserModel,
            noDataText: 'Sin usuarios.',
            noObject: true,
            rules: [RequiredRule],
        },
    },
    {
        name: 'wh_warehouse_id',
        type: 'autocomplete-model',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            itemText: 'name',
            itemValue: 'id',
            label: 'Bodega',
            model: WarehouseModel,
            noDataText: 'Sin usuarios.',
            noObject: true,
            rules: [RequiredRule],
        },
    },
    {
        name: 'pch_provider_id',
        type: 'autocomplete-model',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            itemKey: 'id',
            itemText: 'rut',
            itemValue: 'id',
            label: 'Rut',
            model: ProviderModel,
            noDataText: 'Sin proveedores.',
            noObject: true,
            rules: [RequiredRule],
        },
        // trigger: props.pch_provider_id_trigger,
    },
    {
        name: 'pch_provider_id',
        type: 'autocomplete-model',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            itemKey: 'id',
            itemText: 'alias_name',
            itemValue: 'id',
            label: 'Proveedor',
            model: ProviderModel,
            noDataText: 'Sin proveedores.',
            noObject: true,
            rules: [RequiredRule],
        },
        trigger(ctx) {
            // get required info
            const branchField = ctx.getField('pch_provider_branch_offices_id'),
                branchSelected = ctx.value.pch_provider_branch_offices_id,
                providerInput = ctx.getInput('pch_provider_id'),
                providerSelected = providerInput.getSelected()

            // set new items
            branchField.props.items =
                providerSelected.branch_offices ||
                providerSelected.pch_provider_branch_offices ||
                []

            // refresh value input
            ctx.value.pch_provider_branch_offices_id = 0
            ctx.value.pch_provider_branch_offices_id = branchSelected

            // set loading true
            //branchField.props.loading = providerInput.loading

            // reset fieldset
            ctx.$refs.fieldset.$forceUpdate()
        },
    },
    {
        name: 'pch_provider_branch_offices_id',
        type: 'autocomplete',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            items: [],
            itemText: 'address',
            itemValue: 'id',
            label: 'Sucursal',
            noDataText: 'Sin sucursales.',
            noObject: true,
            rules: [RequiredRule],
        },
    },
    {
        name: 'pch_purchase_order_state_name',
        type: 'text-field',
        flex: {
            sm3: true,
            xs12: true,
        },
        props: {
            label: 'Estado',
            readonly: true,
        },
    },
    {
        name: 'invoiceNumbers',
        type: 'text-field',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            label: 'Factura(s)',
            readonly: true,
        },
    },
    {
        name: 'created_at',
        type: 'date-field',
        flex: {
            sm3: true,
            xs12: true,
        },
        props: {
            label: 'Creado',
            readonly: true,
        },
    },
    {
        name: 'receiving_date',
        type: 'date-field',
        flex: {
            sm3: true,
            xs12: true,
        },
        props: {
            label: 'Recepcion',
            readonly: true,
        },
    },
    {
        name: 'pch_selected_purchase_orders',
        type: 'table-field',
        flex: {
            'pt-0': true,
            xs12: true,
            'd-grid': true,
        },
        props: {
            checkable: true,
            headers: props.is_service ? DetailPurchaseOrderHeaders.forService : DetailPurchaseOrderHeaders.forProduct,
            //headers: PurchaseOrderDetailHeaders,
            noDataText: 'Sin productos.',
            pickerProps: {
                attachParams: {
                    cost_price_branch_office_id: props.g_branch_office_id,
                    last_provider_code_provider_id: props.pch_provider_id,
                },
                filters: props.is_service ? ProductServiceFilters : ProductFilters,
                headers: props.is_service ? ProductServiceHeaders : ProductHeaders.exclude(['wh_item_is_inventoriable', 'is_repackaged']),
                noPagination: false,
                initialFilterValues: {
                    is_cyclic: props.is_service ? true : undefined,
                },
                mapperFilter: filters => ({
                    ...filters,
                    product_provider_code: props.pch_provider_id && filters.product_provider_code ? `${props.pch_provider_id},${filters.product_provider_code}` : undefined
                }),
                paramSearch: props.is_service ? 'name' : 'search',
                parser: selected_parser(props),
                rowsPerPage: 15,
                submitText: 'confirmar selección',
                service: props.is_service ? ProductServiceModel : ProductModel,
                title: 'Seleccionar producto',
            },
            selectedKey: props.is_service ? 'wh_product_service_id' : 'wh_product_id',
            //showAdder: props.is_service,
            showPicker: true,
            toolbarTitle: 'Lista de productos incluidos en la orden',
        },
    },
    {
        name: 'wh_orderers',
        type: 'table-field',
        flex: {
            'pt-0': true,
            xs12: true,
            'd-grid': true,
        },
        props: {
            checkable: true,
            class: 'v-card elevation-2 mb-4',
            headers: PurchaseOrderOrdererHeaders,
            noDataText: 'Sin solicitudes de abastecimiento relacionadas.',
            showNativePagination: true,
            toolbarTitle: 'Lista de solicitudes de abastecimiento relacionadas',
            readonly: true,
        },
    },
    {
        name: 'observation',
        type: 'textarea',
        flex: {
            xs12: true,
            sm6: true,
        },
        props: {
            label: 'Observación',
        },
    },
    {
        name: 'reception_comment',
        type: 'textarea',
        flex: {
            xs12: true,
            sm6: true,
        },
        props: {
            label: 'Comentario de recepción',
            readonly: true,
        },
    },
    {
        name: 'pch_payment_condition_id',
        type: 'autocomplete-model',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            itemText: 'type',
            itemValue: 'id',
            label: 'Método de pago',
            model: PaymentConditionModel,
            noDataText: 'Sin condiciones de pago.',
            noObject: true,
            paramSearch: 'type',
            rules: [RequiredRule],
        },
    },
    {
        name: 'is_exent',
        type: 'switch',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            label: 'Exento',
        },
    },
    {
        name: 'pch_selected_purchase_orders_net_price',
        type: 'currency-field',
        flex: {
            'offset-lg3': true,
            sm6: true,
            lg3: true,
        },
        props: {
            label: 'Total neto',
            readonly: true,
            reverse: true,
        },
    },
]
